import BaseService from './BaseService';
import entities from 'src/config/entities';
import axios from 'axios'
class ResumeService extends BaseService{

  constructor() {
    super({ entity: entities.RESUME });
  }

  async getResumeHistory(resumeId) {
    const res = await axios.get(`resume/${resumeId}/resume-history`)
    return res.data
  }
  async createResumeHistory(resumeId, data) {
    const res = await axios.post(`resume/${resumeId}/resume-history`, data)
    return res.data
  }

  async updateResumeHistory(resumeId, data) {
    const res = await axios.put(`resume/${resumeId}/resume-history/${data.uuid}`, data)
    return res.data
  }

  async deleteResumeHistory(resumeId, resumeHistoryId) {
    const res = await axios.delete(`resume/${resumeId}/resume-history/${resumeHistoryId}`)
    return res.data
  }
}

export default new ResumeService();
